"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dbKeys_getFlatList = exports.dbKeys_reloadFolder = exports.dbKeys_refreshAll = exports.dbKeys_markNodeExpanded = exports.dbKeys_loadMissing = void 0;
const omit_1 = __importDefault(require("lodash/omit"));
const SHOW_INCREMENT = 100;
// function dbKeys_findFolderNode(node: DbKeysNodeModel, root: string) {
//   if (node.type != 'dir') {
//     return null;
//   }
//   if (node.root === root) {
//     return node;
//   }
//   for (const child of node.children ?? []) {
//     const res = dbKeys_findFolderNode(child, root);
//     if (res) {
//       return res;
//     }
//   }
//   return null;
// }
// export async function dbKeys_loadKeysFromNode(
//   tree: DbKeysTreeModel,
//   callingRoot: string,
//   separator: string,
//   loader: DbKeysLoadFunction
// ): Promise<DbKeysTreeModel> {
//   const callingRootNode = tree.dirsByKey[callingRoot];
//   if (!callingRootNode) {
//     return tree;
//   }
//   const newItems = await loader(callingRoot, callingRootNode.maxShowCount ?? SHOW_INCREMENT);
//   return {
//     ...tree,
//     childrenByKey: {
//       ...tree.childrenByKey,
//       [callingRoot]: newItems,
//     },
//   };
// }
function dbKeys_loadMissing(tree, loader) {
    return __awaiter(this, void 0, void 0, function* () {
        const childrenByKey = Object.assign({}, tree.childrenByKey);
        const dirsByKey = Object.assign({}, tree.dirsByKey);
        for (const root in tree.dirsByKey) {
            const dir = tree.dirsByKey[root];
            if (dir.isExpanded && dir.shouldLoadNext) {
                if (!tree.childrenByKey[root] || dir.hasNext) {
                    const loadCount = dir.maxShowCount && dir.shouldLoadNext ? dir.maxShowCount + SHOW_INCREMENT : SHOW_INCREMENT;
                    const items = yield loader(root, loadCount + 1);
                    childrenByKey[root] = items.slice(0, loadCount);
                    dirsByKey[root] = Object.assign(Object.assign({}, dir), { shouldLoadNext: false, maxShowCount: loadCount, hasNext: items.length > loadCount });
                    for (const child of items.slice(0, loadCount)) {
                        if (child.type == 'dir' && !dirsByKey[child.root]) {
                            dirsByKey[child.root] = {
                                shouldLoadNext: false,
                                maxShowCount: null,
                                hasNext: false,
                                isExpanded: false,
                                type: 'dir',
                                level: dir.level + 1,
                                root: child.root,
                                text: child.text,
                            };
                        }
                    }
                }
                else {
                    dirsByKey[root] = Object.assign(Object.assign({}, dir), { shouldLoadNext: false });
                }
            }
        }
        return Object.assign(Object.assign({}, tree), { dirsByKey,
            childrenByKey, refreshAll: false });
    });
}
exports.dbKeys_loadMissing = dbKeys_loadMissing;
function dbKeys_markNodeExpanded(tree, root, isExpanded) {
    const node = tree.dirsByKey[root];
    if (!node) {
        return tree;
    }
    return Object.assign(Object.assign({}, tree), { dirsByKey: Object.assign(Object.assign({}, tree.dirsByKey), { [root]: Object.assign(Object.assign({}, node), { isExpanded, shouldLoadNext: isExpanded }) }) });
}
exports.dbKeys_markNodeExpanded = dbKeys_markNodeExpanded;
function dbKeys_refreshAll(tree) {
    const root = {
        isExpanded: true,
        level: 0,
        root: '',
        type: 'dir',
        shouldLoadNext: true,
    };
    return Object.assign(Object.assign({}, tree), { childrenByKey: {}, dirsByKey: {
            '': root,
        }, refreshAll: true, root });
}
exports.dbKeys_refreshAll = dbKeys_refreshAll;
function dbKeys_reloadFolder(tree, root) {
    return Object.assign(Object.assign({}, tree), { childrenByKey: (0, omit_1.default)(tree.childrenByKey, root), dirsByKey: Object.assign(Object.assign({}, tree.dirsByKey), { [root]: Object.assign(Object.assign({}, tree.dirsByKey[root]), { shouldLoadNext: true, hasNext: undefined }) }) });
}
exports.dbKeys_reloadFolder = dbKeys_reloadFolder;
function addFlatItems(tree, root, res) {
    const item = tree.dirsByKey[root];
    if (!item.isExpanded) {
        return false;
    }
    const children = tree.childrenByKey[root] || [];
    for (const child of children) {
        res.push(child);
        if (child.type == 'dir') {
            addFlatItems(tree, child.root, res);
        }
    }
}
function dbKeys_getFlatList(tree) {
    const res = [];
    addFlatItems(tree, '', res);
    return res;
}
exports.dbKeys_getFlatList = dbKeys_getFlatList;
